// src/components/multi-product-search-form/multi-product-search-form.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query ProductSelectorQuery($context: ContextInput!) {\n    searchForm(context: $context) {\n      productSelector {\n        products {\n          clickAnalytics {\n            linkName\n            referrerId\n          }\n          id\n          label\n          selected\n          type\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  query SearchFormBackgroundImageQuery($context: ContextInput!, $uriContext: UriContextInput!, $contentTopic: String!, $experienceType: String!) {\n    travelExperienceManagerContent(context: $context, uriContext: $uriContext, contentTopic: $contentTopic, experienceType: $experienceType) {\n      editorialComponent {\n        content {\n          ... on EMMediaComponents {\n            items {\n              mediaType {\n                ... on Image {\n                  description\n                  src: url\n                  aspectRatio\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React2 from "react";
import { SearchForm as ActivitiesSearchForm } from "@shared-ui/retail-search-tools-activity";
import { SearchForm as CarsSearchForm } from "@shared-ui/retail-search-tools-cars";
import { SearchForm as CruisesSearchForm } from "@shared-ui/retail-search-tools-cruises";
import { SearchForm as FlightsSearchForm } from "@shared-ui/retail-search-tools-flights";
import { PackageType, SearchForm as PackagesSearchForm } from "@shared-ui/retail-search-tools-multi-item";
import { SearchForm as LodgingSearchForm } from "@shared-ui/search-tools-lodging";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCard } from "uitk-react-cards";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/product-selector/product-selector.tsx
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
var __Query = gql(_templateObject());
var ProductSelector = function(props) {
    var _data_searchForm, _data_searchForm_productSelector;
    var inputs = props.inputs, skipSsr = props.skipSsr, skipQuery = props.skipQuery, onProductTypeSelection = props.onProductTypeSelection, batchKey = props.batchKey, initialSelectedProduct = props.initialSelectedProduct;
    var context = useBexApi().context;
    var track = useClickTracker();
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: !!skipQuery
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var _data_searchForm_productSelector_products;
    var products = (_data_searchForm_productSelector_products = data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : (_data_searchForm_productSelector = _data_searchForm.productSelector) === null || _data_searchForm_productSelector === void 0 ? void 0 : _data_searchForm_productSelector.products) !== null && _data_searchForm_productSelector_products !== void 0 ? _data_searchForm_productSelector_products : [];
    var initialTabIndex = products.findIndex(function(param) {
        var type = param.type;
        return type === initialSelectedProduct;
    });
    var _React_useState = _slicedToArray(React.useState(initialTabIndex !== -1 ? initialTabIndex : 0), 2), selectedTabIndex = _React_useState[0], setSelectedTabIndex = _React_useState[1];
    if (loading || error || !data || products.length <= 1) {
        return null;
    }
    var handleTabSelect = function(selectedTab) {
        var _products_selectedTab = products[selectedTab], clickAnalytics = _products_selectedTab.clickAnalytics, type = _products_selectedTab.type;
        if (clickAnalytics) {
            var linkName = clickAnalytics.linkName, referrerId = clickAnalytics.referrerId;
            track(referrerId, linkName);
        }
        setSelectedTabIndex(selectedTab);
        onProductTypeSelection(type);
    };
    var tabsProps = {
        selectedTab: selectedTabIndex,
        onTabSelect: handleTabSelect,
        tabsType: UitkTabsType.NATURAL,
        targetURI: ""
    };
    return /* @__PURE__ */ React.createElement(Viewport, null, /* @__PURE__ */ React.createElement(ViewSmall, null, /* @__PURE__ */ React.createElement(UitkTabs, _objectSpread({}, tabsProps), products.map(function(param) {
        var id = param.id, label = param.label;
        return /* @__PURE__ */ React.createElement(UitkTab, {
            key: id,
            name: label,
            targetURI: label
        });
    }))), /* @__PURE__ */ React.createElement(ViewMedium, null, /* @__PURE__ */ React.createElement(UitkTabs, _objectSpreadProps(_objectSpread({}, tabsProps), {
        centerAlign: true
    }), products.map(function(param) {
        var id = param.id, label = param.label;
        return /* @__PURE__ */ React.createElement(UitkTab, {
            key: id,
            name: label,
            targetURI: label
        });
    }))));
};
ProductSelector.displayName = "ProductSelector";
// src/components/multi-product-search-form/multi-product-search-form.tsx
var MultiProductSearchForm = function(param) {
    var batchKey = param.batchKey, initialSelectedProduct = param.initialSelectedProduct, handleProductSelect = param.handleProductSelect;
    var _React2_useState = _slicedToArray(React2.useState(initialSelectedProduct), 2), product = _React2_useState[0], setProduct = _React2_useState[1];
    var handleProductSelection = function(newProduct) {
        setProduct(newProduct);
        handleProductSelect === null || handleProductSelect === void 0 ? void 0 : handleProductSelect(newProduct);
    };
    var commonProps = {
        batchKey: batchKey,
        /* istanbul ignore next */ onFieldChange: function() {},
        redirectToSearchResultOnSubmit: true
    };
    var forms = {
        LODGING: /* @__PURE__ */ React2.createElement(LodgingSearchForm, _objectSpreadProps(_objectSpread({}, commonProps), {
            inputs: {}
        })),
        FLIGHTS: /* @__PURE__ */ React2.createElement(FlightsSearchForm, _objectSpreadProps(_objectSpread({}, commonProps), {
            inputs: {
                includeFlightType: true
            }
        })),
        CARS: /* @__PURE__ */ React2.createElement(CarsSearchForm, _objectSpreadProps(_objectSpread({}, commonProps), {
            inputs: {}
        })),
        PACKAGES: /* @__PURE__ */ React2.createElement(PackagesSearchForm, _objectSpreadProps(_objectSpread({}, commonProps), {
            inputs: {
                packageSearchCriteria: {
                    primary: {}
                },
                packageType: PackageType.FLIGHT_HOTEL,
                includePackageType: true
            }
        })),
        ACTIVITIES: /* @__PURE__ */ React2.createElement(ActivitiesSearchForm, _objectSpreadProps(_objectSpread({}, commonProps), {
            inputs: {}
        })),
        CRUISES: /* @__PURE__ */ React2.createElement(CruisesSearchForm, _objectSpreadProps(_objectSpread({}, commonProps), {
            inputs: {}
        }))
    };
    var form = /* @__PURE__ */ React2.createElement("div", null, forms[product]);
    var productSelector = /* @__PURE__ */ React2.createElement(ProductSelector, {
        batchKey: batchKey,
        inputs: {},
        onProductTypeSelection: handleProductSelection,
        initialSelectedProduct: initialSelectedProduct
    });
    return /* @__PURE__ */ React2.createElement(Viewport2, null, /* @__PURE__ */ React2.createElement(ViewSmall2, null, /* @__PURE__ */ React2.createElement(React2.Fragment, null, productSelector, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, form))), /* @__PURE__ */ React2.createElement(ViewMedium2, null, /* @__PURE__ */ React2.createElement(UitkCard, {
        border: true,
        overflow: true
    }, /* @__PURE__ */ React2.createElement("div", null, productSelector, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: "six"
    }, form)))));
};
// src/components/search-form-with-background-image/search-form-with-background-image.tsx
import React4 from "react";
import { gql as gql2, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
// src/components/search-form-with-background-image/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
// src/__generated__/globalTypes.ts
var SearchFormProductType = /* @__PURE__ */ function(SearchFormProductType2) {
    SearchFormProductType2["ACTIVITIES"] = "ACTIVITIES";
    SearchFormProductType2["CARS"] = "CARS";
    SearchFormProductType2["CRUISES"] = "CRUISES";
    SearchFormProductType2["FLIGHTS"] = "FLIGHTS";
    SearchFormProductType2["LODGING"] = "LODGING";
    SearchFormProductType2["PACKAGES"] = "PACKAGES";
    return SearchFormProductType2;
}(SearchFormProductType || {});
var _obj;
// src/components/search-form-with-background-image/utils/aspect-ratio-mapper.ts
var aspectRatioMapper = (_obj = {}, _defineProperty(_obj, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _defineProperty(_obj, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _defineProperty(_obj, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _defineProperty(_obj, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _defineProperty(_obj, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _defineProperty(_obj, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _defineProperty(_obj, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj);
// src/components/search-form-with-background-image/components/search-form.tsx
import React3 from "react";
import { UitkCard as UitkCard2, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var SearchForm = function(param) {
    var batchKey = param.batchKey, initialSelectedProduct = param.initialSelectedProduct;
    return /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
        minWidth: "full_width",
        maxWidth: "full_width"
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            blockstart: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React3.createElement("section", {
        "data-testid": "multi-product-search-form-with-background-image"
    }, /* @__PURE__ */ React3.createElement(UitkCard2, {
        border: true
    }, /* @__PURE__ */ React3.createElement(UitkCardContentSection, null, /* @__PURE__ */ React3.createElement(MultiProductSearchForm, {
        batchKey: batchKey,
        initialSelectedProduct: initialSelectedProduct
    }))))))));
};
// src/components/search-form-with-background-image/search-form-with-background-image.tsx
var __Query2 = gql2(_templateObject1());
var SearchFormWithBackgroundImage = function(props) {
    var _content_items, _content_items_;
    var batchKey = props.batchKey, initialSelectedProduct = props.initialSelectedProduct, inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi2().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading || error || !data || !data.travelExperienceManagerContent.editorialComponent || !data.travelExperienceManagerContent.editorialComponent.content) {
        return /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(SearchForm, {
            batchKey: batchKey,
            initialSelectedProduct: initialSelectedProduct
        }));
    }
    var content = data.travelExperienceManagerContent.editorialComponent.content;
    if (content.__typename !== "EMMediaComponents" || ((_content_items = content.items) === null || _content_items === void 0 ? void 0 : _content_items.length) !== 1 || ((_content_items_ = content.items[0]) === null || _content_items_ === void 0 ? void 0 : _content_items_.mediaType.__typename) !== "Image") {
        return /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(SearchForm, {
            batchKey: batchKey,
            initialSelectedProduct: initialSelectedProduct
        }));
    }
    var _content_items__mediaType = content.items[0].mediaType, aspectRatio = _content_items__mediaType.aspectRatio, description = _content_items__mediaType.description, src = _content_items__mediaType.src;
    return /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkLayoutGrid, null, /* @__PURE__ */ React4.createElement(Viewport3, null, /* @__PURE__ */ React4.createElement(ViewSmall3, null, /* @__PURE__ */ React4.createElement(SearchForm, {
        batchKey: batchKey,
        initialSelectedProduct: initialSelectedProduct
    })), /* @__PURE__ */ React4.createElement(ViewMedium3, null, /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React4.createElement(UitkFigure, {
        ratio: aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R4_1
    }, /* @__PURE__ */ React4.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: src
    })), /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            top: "center",
            right: "four",
            left: "four"
        }
    }, /* @__PURE__ */ React4.createElement(SearchForm, {
        batchKey: batchKey,
        initialSelectedProduct: initialSelectedProduct
    })))))));
};
SearchFormWithBackgroundImage.displayName = "SearchFormWithBackgroundImage";
export { MultiProductSearchForm, SearchFormProductType, SearchFormWithBackgroundImage };
//# sourceMappingURL=index.js.map